import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseDeletePublicCompanyLeadGenericDocumentProps {
  publicCompanyLeadId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useDeletePublicCompanyLeadGenericDocument = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseDeletePublicCompanyLeadGenericDocumentProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['deletePublicCompanyLeadGenericDocument'],
    mutationFn: (attachment_id: string) => {
      const lead = {
        generic_documents_attachments_attributes: [
          {
            id: attachment_id,
            _destroy: true,
          },
        ],
      }

      return privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
